<template>
  <vxe-grid
    resizable
    :data="list"
    :columns="columns" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'ServiceWorker',
  mixins: [WindowsMixin, ListMixin],
  props: {
    getParams: {
      type: Object,
    },
    data: {
      type: Object,
      required: true,
    },
    cloudEnv: String,
  },
  data () {
    return {
      list: [],
      columns: [
        {
          field: 'name',
          title: this.$t('table.title.name'),
          sortable: true,
        },
        {
          field: 'active_worker_cnt',
          title: 'active_worker_cnt',
          sortable: true,
        },
        {
          field: 'detach_worker_cnt',
          title: 'detach_worker_cnt',
          sortable: true,
        },
        {
          field: 'max_worker_cnt',
          title: 'max_worker_cnt',
          sortable: true,
        },
        {
          field: 'queue_cnt',
          title: 'queue_cnt',
          sortable: true,
        },
        {
          field: 'allow_overflow',
          title: 'allow_overflow',
          sortable: true,
        },
        {
          field: 'backlog',
          title: 'backlog',
          sortable: true,
        },
        {
          field: 'db_worker',
          title: 'db_worker',
          sortable: true,
        },
      ],
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      try {
        let response
        if (this.cloudEnv === 'host') {
          response = await new this.$Manager(`hosts/${this.data.id}/worker-stats`, 'v1').list()
        } else {
          response = await new this.$Manager('stats/worker_stats', 'v1').list({
            params: {
              service: this.data.type,
            },
          })
        }
        this.list = response.data?.workers || []
      } catch (error) {
        this.$Message.error(error.message)
      }
    },
  },
}
</script>
